



































import Component from 'vue-class-component';
import { Prop, VModel } from 'vue-property-decorator';
import Vue from 'vue';
import { FacilityAutocompleteModel } from '@/context/facility/model/FacilityAutocompleteModel';
import { facilityApi } from '@/context/facility/api/FacilityApi';

@Component({})
export default class FacilityAutocomplete extends Vue {
  @VModel({ type: FacilityAutocompleteModel })
  model!: FacilityAutocompleteModel;
  @Prop({
    default: "",
    type: String
  })
  queryParam!: string;
  @Prop({
    type: Array,
    default: () => []
  })
  rules: [] = [];
  @Prop({
    type: Boolean,
    default: false
  })
  multiple: boolean = false;
  @Prop({
    type: Boolean,
    default: false
  })
  returnObject: boolean = false;
  items: FacilityAutocompleteModel[] = [];
  loading = false;
  search = "";

  mounted(): void {
    this.loadItems();
  }

  async loadItems(): Promise<void> {
    this.loading = true;
    this.items = await facilityApi.autocomplete("", {});
    this.loading = false;
  }
}
